import Headline from '../../../../components/Headline';
import Description from '../../../../components/Description';
import Input from '../../../../components/Input';
import List from '../../../../components/List';
import { Fragment, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { selectProduct } from '../../../../../../../store/selectors/products';
import { isValidNotificationUrl } from '../helpers';

const Limits = () => {
  const dispatch = useDispatch();
  const { data } = useSelector(selectProduct);
  const [urlValidity, setUrlValidity] = useState({
    testNotificationUrl: true,
    prodNotificationUrl: true,
  });

  const handleInputChange = useCallback((event) => {
    const type = event.target.getAttribute('data-value');
    const value = event.target.value;

    setUrlValidity((prev) => ({
      ...prev,
      [type]: isValidNotificationUrl(value),
    }));

    dispatch({
      type: 'BROKER_PRODUCT_LIMITS',
      payload: {
        [type]: value,
      },
    });
  }, [dispatch]);

  return (
    <Fragment>
      <Headline message='Integration limits headline' />

      <Description message='Integration limits description' />

      <List direction='column'>
        <Input
          value={data?.notificationUrls?.testNotificationUrl}
          label='Test environment'
          placeholder='Paste link'
          dataValue='testNotificationUrl'
          onChange={handleInputChange}
          validated={urlValidity.testNotificationUrl}
        />

        <Input
          value={data?.notificationUrls?.prodNotificationUrl}
          label='Production environment'
          placeholder='Paste link'
          dataValue='prodNotificationUrl'
          onChange={handleInputChange}
          validated={urlValidity.prodNotificationUrl}
        />
      </List>
    </Fragment>
  );
};

export default Limits;
